 <template>
  <div class="celebrate">
      <div class="c-images">
        <img src="@/assets/celebrations/like.png" class="icon-like animate">
        <img src="@/assets/celebrations/celebrate.png" class="icon-celebrate animate">
        <img src="@/assets/celebrations/balloon.png" class="icon-balloon animate">
        <img src="@/assets/celebrations/heart.png" class="icon-heart animate">
        <img src="@/assets/celebrations/ribbon.png" class="icon-ribbon animate">
        <img src="@/assets/celebrations/clap.png" class="icon-hand animate">
        <img src="@/assets/celebrations/arrow.png" class="icon-arrow animate">
      </div>
    <div class="celebrate-container">
      <div class="c-content">
        <h6 v-if="title"  class="title is-6 heading">{{title}}</h6>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      require: true
    }
  }
}
</script>

<style lang="scss" scoped>
.heading {
  margin-bottom: 0.5rem;
}
@keyframes float {
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-20px);
  }
  100% {
    transform: translatey(0px);
  }
}

.celebrate-container{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.c-images {
  position: relative;
  height: 200px;
}
.animate {
  overflow: hidden;
  transform: translatey(0px);
  animation: float 6s ease-in-out infinite;
}

.icon-like {
  width: 40px;
  height: 40px;
  object-fit: contain;
  position: absolute;
  top: 40px;
  left: 35.375%;
}

.icon-celebrate {
  width: 80px;
  height: 80px;
  object-fit: contain;
  position: absolute;
  top: 64px;
  left: 42.1875%;
}

.icon-balloon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  position: absolute;
  top: 32px;
  left: 56.8125%;
}

.icon-heart {
  width: 40px;
  height: 40px;
  object-fit: contain;
  position: absolute;
  top: 67px;
  left: 66.53125%;
}

.icon-ribbon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  position: absolute;
  left: 59.71875%;
  top: 107px;
}

.icon-hand {
  width: 40px;
  height: 40px;
  object-fit: contain;
  position: absolute;
  top: 122px;
  left: 32.46875%;
}

.icon-arrow {
  width: 40px;
  height: 40px;
  object-fit: contain;
  position: absolute;
  left: 25.65625%;
  top: 80px;
}

.textContainer {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/general/celebrate-graphics.vue